// extracted by mini-css-extract-plugin
export default {"popover-trigger":"Trigger-module__popover-trigger___XpMpl"};